import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getAllProperty = async (params) => {
  const data = await apiCall("post", apiEndPoints.PROPERTYLIST, params);
  return data;
};
const getAgentProperty = async (params) => {
  const data = await apiCall("post", apiEndPoints.PROPERTYLISTBYAGENT, params);
  return data;
};
const propertyCheck = async (params) => {
  const data = await apiCall("post", apiEndPoints.PROPERTYCHECK, params);
  return data;
};
const addProperty = async (params) => {
  const data = await apiCall("post", apiEndPoints.ADDPROPERTY, params, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
  return data;
};
const editProperty = async (params) => {
  const data = await apiCall("post", apiEndPoints.EDITPROPERTY, params, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
  return data;
};
const getPropertyDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETPROPERTYDETAIL, params);
  return data;
};
const getPropertyFilterDetail = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETPROPERTYFILTERDETAIL,
    params
  );
  return data;
};
const propertyStatusUpdate = async (params) => {
  const data = await apiCall("post", apiEndPoints.PROPERTYSTATUSUPDATE, params);
  return data;
};

const getConfigurationPropList = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.PROPERTYCONFIGURATIONLIST,
    params
  );
  return data;
};
const propertyDocumentDelete = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.PROPERTYDOCUMENTDELETE,
    params
  );
  return data;
};

const syncAllProjects = async (params) => {
  const data = await apiCall("post", apiEndPoints.SYNCALLPROJECT, params);
  return data;
};

const getPropertyBasedSM = async (params) => {
  const data = await apiCall("post", apiEndPoints.GET_PROPERTY_BASED_SM, params);
  return data;
};

const propertyService = {
  getAllProperty,
  getAgentProperty,
  propertyCheck,
  addProperty,
  editProperty,
  getPropertyDetail,
  getPropertyFilterDetail,
  propertyStatusUpdate,
  getConfigurationPropList,
  propertyDocumentDelete,
  syncAllProjects,
  getPropertyBasedSM,
};

export default propertyService;
